<template>
    <el-dialog title="材料账户明细" :visible.sync="isVisible" width="80%" @close="handleClose">
        <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
            @search-change="searchChange" @refresh-change="refreshChange(page)" @size-change="pageSizeChange"
            @current-change="pageChange">
        </avue-crud>
    </el-dialog>
</template>
<script>
// import { mapGetters } from "vuex";
import { materialAccountDetailTableOption } from "@/const/work/waterProof/materialAccountOption";
import { getMaterialAccountDetail, transferGroupUser, findEngineerList } from "@/api/work/waterProof/materialAccount";
import { findUser } from '@/api/sales/accountGroup';
export default {
    name: 'GroupDetails',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        userId: {
            type: [Number, String],
            required: true
        }
    },
    watch: {
        visible(newVal) {
            this.isVisible = newVal;
            if (newVal && this.userId) {
                this.handleDetailList();
            }
        },
        userId(newVal) {
            if (this.visible && newVal) {
                this.handleDetailList();
            }
        }
    },
    data() {
        return {
            isVisible: this.visible,
            tableOption: materialAccountDetailTableOption, //表格设置属性
            tableData: [], //表格的数据
            tableLoading: false,
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            // 保存要转移的记录
            transferSelections: [],
            // 转移分组表单
            transferForm: {
                targetGroupId: ''
            },
            transferDialogVisible: false,
            // 可选分组列表
            groupList: [],
            // 工程师列表
            engineerList: []
        };
    },
    created() {
        this.getGroupList();
        this.loadEngineerList();
    },
    methods: {
        handleDetailList() {
            if (!this.userId) return;
            this.tableLoading = true;
            const params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
                type: 'WATERPROOF'
            };
            getMaterialAccountDetail(this.userId,params )
                .then(res => {
                    this.tableLoading = false;
                    if (res.code === '200') {
                        const data = JSON.parse(res.data) || [];
                        console.log('materialAccountDetail.vue ~ line: 109 ~ data ->', data);
                        this.tableData = data.rows || [];
                        // 由于接口返回的是数组而不是分页对象，这里根据实际情况设置总数
                        this.page.total = data.total || 0;
                    } else {
                        this.tableData = [];
                        this.page.total = 0;
                        this.$message.error('获取材料账户明细失败');
                    }
                })
                .catch(error => {
                    console.log('materialAccountDetail.vue ~ line: 119 ~ error ->', error);
                    this.tableLoading = false;
                    this.tableData = [];
                    this.page.total = 0;
                    this.$message.error('获取材料账户明细异常');
                });
        },
        pageChange(page) {
            this.page.currentPage = page;
            this.handleDetailList();
        },
        pageSizeChange(pageSize) {
            this.page.pageSize = pageSize;
            this.handleDetailList();
        },
        searchChange(params) {
            this.page.currentPage = 1;
            const searchParams = {
                userId: this.userId,
                page: 1,
                size: this.page.pageSize
            };
            // 添加搜索参数
            if (params.userName) {
                searchParams.userName = params.userName;
            }
            if (params.userMobile) {
                searchParams.userMobile = params.userMobile;
            }
            this.tableLoading = true;
            getMaterialAccountDetail(searchParams)
                .then(res => {
                    this.tableLoading = false;
                    if (res.code === '200') {
                        const data = JSON.parse(res.data) || [];
                        console.log('materialAccountDetail.vue ~ line: 160 ~ data ->', data);
                        this.tableData = data.rows || [];
                        this.page.total = data.total || 0;
                    } else {
                        this.tableData = [];
                        this.page.total = 0;
                        this.$message.error('搜索材料账户明细失败');
                    }
                })
                .catch(error => {
                    console.log('materialAccountDetail.vue ~ line: 163 ~ error ->', error);
                    this.tableLoading = false;
                    this.tableData = [];
                    this.page.total = 0;
                    this.$message.error('搜索材料账户明细异常');
                });
        },
        refreshChange(page) {
            this.page.currentPage = page.currentPage;
            this.page.pageSize = page.pageSize;
            this.handleDetailList();
        },
        handleClose() {
            this.$emit('close');
        },
        loadEngineerList() {
            findEngineerList().then(res => {
                if (res.code == '200') {
                    this.engineerList = JSON.parse(res.data);
                }
            });
        },
        // 处理删除按钮点击
        handleDelete(row) {
            let selections;
            // 如果传入了行数据，则为单个删除
            if (row && row.id) {
                selections = [row];
            } else {
                // 否则为批量删除
                selections = this.$refs.crud.$refs.table.selection;
                if (!selections || selections.length === 0) {
                    this.$message.warning('请先选择要删除的记录');
                    return;
                }
            }
            this.$confirm('确定要删除选中的 ' + selections.length + ' 条记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirmDelete(selections);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        // 确认删除材料账户明细
        confirmDelete(selections) {
            const ids = selections.map(item => item.id).join(',');
            console.log('materialAccountDetail.vue ~ line: 212 ~ ids ->', ids);
            this.tableLoading = true;
            // 注意：这里应该调用材料账户明细删除API，当前没有提供，暂时模拟删除成功
            setTimeout(() => {
                this.tableLoading = false;
                this.$message.success('删除成功');
                this.handleDetailList(); // 重新加载列表
            }, 500);
        },
        // 处理转移按钮点击
        handleTransfer(row) {
            // 保存当前要转移的记录（可能是单行或多行选中的）
            if (row && row.id) {
                // 如果传入了行数据，则为单个转移
                this.transferSelections = [row];
            } else {
                // 否则尝试获取批量选中的记录
                this.transferSelections = this.$refs.crud.$refs.table.selection;
                if (!this.transferSelections || this.transferSelections.length === 0) {
                    this.$message.warning('请选择要转移的记录');
                    return;
                }
            }
            // 获取分组列表
            this.getGroupList();
            this.transferForm = {
                targetGroupId: ''
            };
            this.transferDialogVisible = true;
        },
        // 获取分组列表
        getGroupList() {
            findUser({ page: 1, size: '' }) // 获取所有分组
                .then(res => {
                    if (res.code === '200') {
                        const data = JSON.parse(res.data);
                        this.groupList = data.rows || [];
                    } else {
                        this.$message.error('获取分组列表失败');
                    }
                })
                .catch(error => {
                    console.log('materialAccountDetail.vue ~ line: 254 ~ error ->', error);
                    this.$message.error('获取分组列表异常');
                });
        },
        // 确认转移材料账户明细
        confirmTransfer() {
            if (!this.transferForm.targetGroupId) {
                this.$message.error('请选择目标分组');
                return;
            }
            if (!this.transferSelections || this.transferSelections.length === 0) {
                this.$message.warning('请选择要转移的记录');
                return;
            }
            // 处理多个转移
            this.tableLoading = true;
            try {
                // 获取选中的ID列表，添加安全检查
                const ids = this.transferSelections
                    .filter(item => item && item.id !== undefined)
                    .map(item => item.id)
                    .join(',');
                if (!ids) {
                    throw new Error('没有获取到有效的记录ID');
                }
                const data = {
                    id: ids,  // 传递多个ID
                    userId: this.userId,
                    targetGroupId: this.transferForm.targetGroupId
                };
                transferGroupUser(data)
                    .then(res => {
                        if (res.code === '200') {
                            this.$message.success('转移成功');
                            this.transferDialogVisible = false;
                            this.handleDetailList(); // 重新加载列表
                        } else {
                            this.$message.error('转移失败：' + (res.message || '未知错误'));
                        }
                    })
                    .catch(error => {
                        console.log('materialAccountDetail.vue ~ line: 295 ~ error ->', error);
                        this.$message.error('转移材料账户明细异常');
                    })
                    .finally(() => {
                        this.tableLoading = false;
                    });
            } catch (error) {
                this.$message.error('处理转移数据异常：' + error.message);
                this.tableLoading = false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__body {
    padding: 15px;
}

/* 表格样式优化 */
.avue-crud__header {
    padding: 10px 0;
}
</style>